import AppState from '../app-state';
import Collection from '@repo/utils/models/Collection';
import type { ID, ReduxAction } from '@repo/utils/types';
import { ActivityItem } from '@repo/utils/models/Activity';

export interface HighlightsState {
  collection: Collection<ActivityItem[]>;
}

const initialHighlightsState = {
  collection: new Collection<ActivityItem[]>(),
};

export const selectHighlights = (contactID: ID) => (state: AppState) =>
  state.data.highlights.collection.items.get(String(contactID), []);

export function highlightsReducer(
  state: HighlightsState = initialHighlightsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_HIGHLIGHTS_SUCCEEDED':
      return {
        ...state,
        collection: state.collection.copyWith({
          items: state.collection.items.set(
            payload.contactID.toString(),
            payload.response.map((highlight) => new ActivityItem(highlight)),
          ),
        }),
      };

    default:
      return state;
  }
}
